import axios from 'axios';
import ProjectDetail from '@/domain/project/project-detail.entity';
import ProjectWithMembers from '@/domain/project/project-with-members.entity';
import snackBarService from '@/shared/snackbar/snackbar.service';

export default class ProjectsSearchService {
  static getAllProjectsByUser(): Promise<ProjectWithMembers[]> {
    return axios.get('/project-api/user-projects-members').then((response: any) => ProjectWithMembers.ofList(response))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }

  static getOneProject(idProject: string): Promise<ProjectDetail> {
    return axios.get(`/project-api/projects/${idProject}`).then((value: any) => ProjectDetail.of(value.data))
      .catch((err: any) => snackBarService.errorMessage(err.response.data.messages));
  }
}
